import { PaletteColor } from "@mui/material/styles";
import { Theme } from "@mui/material";

export function calcColor(error: PaletteColor, warning: PaletteColor, success: PaletteColor, value: number): string {
  return value < 50.0 ? error.light : value < 85.0 ? warning.dark : success.light;
}

export function calcColorFromTheme(theme: Theme, value: number): string {
  return calcColor(theme.palette.error, theme.palette.warning, theme.palette.success, value);
}
